export const darkTheme = {
  bg: "#15171E",
  bgLight: "#1C1E27",
  bgDark: "#15171E",
  primary: "#854CE6",
  menubar: "#12141c",
  menu_primary_text: "#F2F3F4",
  menu_secondary_text: "#b1b2b3",
  table_header: "#11121a",
  text_primary: "#F2F3F4",
  text_secondary: "#b1b2b3",
  card: "#1C1E27",
  card_light: "#191924",
  button:
    "-webkit-linear-gradient(225deg, rgb(132, 0, 255) 0%, rgb(230, 0, 255) 100%);",
  gradient_primary:
    "-webkit-linear-gradient(225deg,rgb(132, 0, 255) 0%,rgb(230, 0, 255) 100%);",
  disabled: "#b1b2b3",
  white: "#FFFFFF",
  black: "#000000",
  green: "#12ff75",
  yellow: "#ffcc00",
  work: "#0d72ff",
  meeting: "#ff9500",
  break: "#ff0dae"
};

export const lightTheme = {
  bg: "#f9f9f9",
  bgLight: "#FFFFFF",
  primary: "#854CE6",
  button:
    "linear-gradient(225deg, rgb(132, 0, 255) 0%, rgb(230, 0, 255) 100%);",
  gradient_primary:
    "-webkit-linear-gradient(225deg, rgb(132, 0, 255) 0%, rgb(230, 0, 255) 100%);",
  disabled: "#b1b2b3",
  menubar: "#191c29",
  menu_primary_text: "#F2F3F4",
  menu_secondary_text: "#b1b2b3",
  table_header: "#242445",
  text_primary: "#404040",
  text_secondary: "#4d4c4c",
  card: "#FFFFFF",
  green: "#00ff6a",
  yellow: "#e8ba00",
  work: "#0d72ff",
  meeting: "#ff9500",
  break: "#ff0dae"
};
